import React from 'react'
import { Link } from 'react-router-dom'
import TimeAgo from 'react-timeago'


class Update6 extends React.Component{



render() {

  return(
  <div>
  <h1 className="introduction-header" >Service 2 Service Authentication</h1>
  <p className="introduction-p-italic">
  By Nathan Sellers <TimeAgo date="May 9, 2019" />
  </p>
    <p className="introduction-p"> The door to our APIs is easier to <span className="orange">Open</span>!</p>
    <p className="introduction-p">
    In an effort to always improve our APIs, Newforma has released a new Authentication Method. In the past authentication was run through Microsoft Azure AD, now
    API users will have the ability to generate an Access Key and Secret Token. The key and token will be used to make a POST request to our /login endpoint which will
    return AWS Signature v4.0 parameters. Once a user has received the AWS parameters these will be used to access any of our endpoints whether they are Newforma enterprise API
    endpoints or our Web/Mobile endpoints.
    <br />
    <br />
    The requirements for this type of access are Newforma Project Center 12.0.7 with +Cloud configured and enabled. For more detailed steps on this type of Authentication please
    visit our Getting-Started page.
    <br />
    <br />
    More Info: <Link to="/getting-started">Getting Started page.</Link>
    </p>


    <p className="introduction-p"> We of course will not be stopping here, everyday our Developers are working hard to create more powerful API resources to give
      you access to the information you need. Please visit the Updates page frequently to keep up with the most recent releases.

    </p>


    </div> )
}
}
export default Update6;



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/update6.js
 **/